<template>
  <div class="depart-wrapper">
    <!-- 列表头部 -->
    <div class="com-list-header">
      <el-form  @keyup.enter.native="getTableList"  class="com-search-box" ref="form" :model="form" label-width="80px">
        <el-row :gutter="20">
          <!-- <el-col :span="5">
            <div class="btn-wrapper">
              <span @click="changeType(item.id)" class="btn" :class="{'active': item.id == selectedIndex}" v-for="(item) in businessList" :key="item.id">部门{{item.name}}</span>
            </div>
          </el-col> -->
          <el-col :span="8">
            <el-form-item label="填报时间 :" prop="year">
              <el-date-picker v-model="form.year" value-format="yyyy" :picker-options="pickerOptions" type="year" placeholder="请选择填报年份">
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="填报人 :" prop="userName">
              <el-input v-model="form.userName" placeholder="请输入填报人"></el-input>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>

      <div class="com-head-search-btns">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="restList">重置</el-button>
      </div>
    </div>
    <div class="com-list-content">
      <div class="button">
        <el-row>
          <el-button class="el-primary-border" round @click="handleCreate()">
            <svg-icon icon-class="add" />&nbsp;添加
          </el-button>
        </el-row>
      </div>
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table ref="multipleTable"  :cell-style="{ textAlign: 'center' }"		 
	:header-cell-style="{textAlign: 'center'}"   v-loading="listLoading" stripe :row-key="(row)=>{ return row.schemeId }" :data="tableData">
          <el-table-column  label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index+1 }}</template>
          </el-table-column>
          <el-table-column  prop="name" label="业务名称" min-width="15%"></el-table-column>
          <el-table-column  prop="createTime" label="创建时间" min-width="15%"></el-table-column>
          <el-table-column  prop="year" label="填报时间" min-width="15%"></el-table-column>
          <!-- <el-table-column  prop="createTimeStr" label="内容" min-width="15%"></el-table-column> -->
          <el-table-column  prop="userName" label="填报人" min-width="14%"></el-table-column>
          <el-table-column  prop="updateTime" label="最后修改时间" min-width="14%"></el-table-column>
          <el-table-column  label="附件" min-width="14%">
            <template slot-scope="scope"><span class="fj-wrapper" @click="download(scope.row)">{{ scope.row.file ? scope.row.file.attName: '' }}</span></template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column  fixed="right" label="操作" min-width="8%">
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="handleEdit( scope.row)">编辑</a>
              <a class="m-btn mr-10 m-danger" @click="handleDelete(scope.row)">删除</a>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

    <el-dialog class="dialog-create-plan" :title="operator==='add' ?'新增部门总结':'编辑部门总结'" :visible.sync="dialogVisible" @close="cancel" width="850px">
      <div class="wrap">
        <el-form class="g-form-grid" ref="addForm" :model="addForm" label-width="120px" :rules="rules">
          <el-form-item label="业务名称 :" prop="name">
            <el-input v-model="addForm.name" placeholder="请输入业务名称"></el-input>
          </el-form-item>

          <el-form-item label="填报时间 :" prop="year">
            <el-date-picker v-model="addForm.year" type="year" value-format="yyyy" :picker-options="pickerOptions" placeholder="请选择填报年份">
            </el-date-picker>
          </el-form-item>

          <!-- <el-form-item label="业务类型 :" prop="typeId">
            <el-select v-model="addForm.typeId" placeholder="请选择业务类型">
              <el-option v-for="item in businessList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item> -->

          <el-form-item label="业务部门 :" prop="deptId">
            <el-select v-model="addForm.deptId" placeholder="请选择业务部门">
              <el-option v-for="item in departmentArr" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="内容 :" prop="content">
            <cmp-ckeditor ref="myCkeditor" :defaultMsg="addForm.content" :toolbarConfig="toolbarConfig" :id="`ue1`" :height="500"></cmp-ckeditor>
          </el-form-item> -->

          <el-form-item label="附件 :" ref="file" prop="fileId">
            <!-- 上传 -->
            <el-upload v-model="addForm.fileId" :limit="1" action="/singleMuseum/attach/upload" :file-list="fileList" :data="configData" :on-preview="handlePreview" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
              <span style="color: #0590ff;">
                <svg-icon icon-class="upload" class="g-icon-upload mr-5" />
                本地上传
              </span>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer" class="footer mt-30">
        <el-button @click="cancel">取消</el-button>
        <el-button @click="onSubmit" type="primary" :loading="loadingSave">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import cmpUploadProgress from '@cmp/my-upload/upload-progress' // 上传组件
import cmpCkeditor from '@cmp/editor/ckeditor'
export default {
  components: {
    cmpUploadProgress,
    cmpCkeditor
  },
  data() {
    const validateFile = (rule, value, callback) => {
      if (!this.addForm.fileId) {
        callback(new Error('附件不能为空'))
      } else {
        callback()
      }
    }
    return {
      pickerOptions: {//el-date-picker 时间限定
        disabledDate(time) {
          // 今天及今天之后的日期
          return time.getTime() > Date.now();
        }
      },
      form: {
        userName: '',
        year: ''
      },
      listQuery: { currentPage: 1, size: 10 },
      addForm: {},
      fileType: '',
      rules: {
        name: [
          { required: true, message: '业务名称不能为空', trigger: 'blur' },
        ],
        year: [{ required: true, message: '填报年份不能为空', trigger: 'blur' }],
        fileId: [{ required: true, validator: validateFile, trigger: 'change' }],
      },
      configData: { tableName: 'collect' },
      operator: 'add',
      total: 0,
      selectedIndex: 1,
      businessList: [{ id: 1, name: '季报' }, { id: 2, name: '年报' }],
      tableData: [],
      fileList: [],
      departmentArr: [],
      listLoading: false,
      loadingSave: false,
      dialogVisible: false,

      // 工具栏自定义配置https://www.geek-share.com/detail/2633938103.html
      // toolbarConfig: [
      //   { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'RemoveFormat'] },
      //   {
      //     name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote',
      //       '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl']
      //   },
      //   { name: 'links', items: ['Link', 'Unlink'] },
      //   { name: 'insert', items: ['Image', 'Table'] },
      //   '/',
      //   { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
      //   { name: 'colors', items: ['TextColor', 'BGColor'] },
      //   { name: 'tools', items: ['Maximize', 'ShowBlocks', '-', 'About'] }
      // ],
    }
  },

  methods: {
    // 查询
    getTableList() {
      this.listQuery.currentPage = 1
      this.getData()
    },

    // 重置
    restList() {
      debugger
      this.selectedIndex = 1
      this.$refs['form'].resetFields()
      this.listQuery.currentPage = 1
      this.getData()
    },

    changeType(dx) {
      this.selectedIndex = dx
    },

    // 获取数据
    getData() {
      this.listLoading = true
      this.tableData = []
      this.$api.approve.getDeptList({
        typeId: 1,
        ...this.form,
        ...this.listQuery
      }).then(res => {
        this.listLoading = false
        if (res.success) {
          if (res.result) {
            this.tableData = res.result
            this.total = res.page.allRow
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },

    // 查询下拉框
    getSelect() {
      this.$http.post('/job/employeeDict', {type: 1}).then(res => {
        if (res.success) {
          let data = res.result
          this.departmentArr = data.department2
        }
      })
    },

    download(obj) {
      location.href = '/singleMuseum/attach/downloadFile?attachmentId=' + obj.fileId
    },

    // 提交
    onSubmit() {
      const self = this
      this.addForm.typeId = 1
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          this.loadingSave = true
          let url = "saveDept"
          // if (this.addForm.id) {
          //   url = "editDept"
          // }
          this.$api.approve[url](this.addForm).then(res => {
            this.loadingSave = false
            if (res.success) {
              this.$message.success({
                message: this.addForm.id ? '部门总结修改成功' : '部门总结新增成功',
                duration: 500,
                onClose() {
                  self.dialogVisible = false
                  self.addForm = {}
                  self.fileList = []
                  self.getData()
                }
              })
            } else {
              this.loadingSave = false
              this.$message.error(res.message)
            }
          })
        } else {
          return false;
        }
      });
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.getData()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.getData()
    },

    // 新增
    handleCreate() {
      this.operator = 'add'
      this.dialogVisible = true
      this.fileList = []
      // 清空弹框数据
      this.addForm = {}
    },

    // 编辑
    handleEdit(obj) {
      this.operator = 'edit'
      this.dialogVisible = true
      this.addForm = JSON.parse(JSON.stringify(obj))
      if (obj.file) {
        this.fileList = [{
          name: obj.file.attName,
          url: obj.file.attPath
        }]
      }
    },

    handleDelete(obj) {
      this.$common.confirm(
        {
          title: `是否确认删除？`,
          className: 'cus-confirm-375'
        }, () => {
          this.$api.approve.delDept({ id: obj.id }).then(res => {
            if (res.success) {
              this.$message.success('删除成功')
              this.getData()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },


    beforeAvatarUpload(file) { },

    handlePreview(file) {
      if (file.url) {
        let fileId = file.url.split('=')[1]
        location.href = '/singleMuseum/attach/downloadFile?attachmentId=' + fileId
      }
    },

    handleAvatarSuccess(res) {
      if (res.success) {
        this.$message.success('上传成功')
        this.addForm.fileId = res.result.attId
        if (this.addForm.fileId) {
          this.$refs['addForm'].clearValidate(['fileId'])
        }
      } else {
        this.$message.error(res.message)
      }
    },

    cancel() {
      this.$refs['addForm'].resetFields()
      this.$refs['addForm'].clearValidate()
      this.fileList = []
      this.loadingSave = false
      this.dialogVisible = false
    }
  },

  mounted() {
    this.getSelect()
    this.getData()
  }
}
</script>

<style lang="scss" scoped>
.depart-wrapper {
  .btn-wrapper {
    .btn {
      box-sizing: border-box;
      display: inline-block;
      min-width: 100px;
      padding: 10px 15px;
      border-radius: 25px;
      border: 1px solid #ebedf2;
      color: #9699a2;
      font-size: 14px;
      cursor: pointer;
      &:first-child {
        margin-right: 20px;
      }

      &.active {
        border-color: #0590ff;
        color: #0590ff;
      }
    }
  }
  /deep/ .el-form-item {
    display: flex;
    .el-form-item__content {
      flex: 1;
      margin-left: 0 !important;
      .el-date-editor {
        width: 100%;
      }

      .el-select {
        width: 100%;
      }
    }

    &.avatar-uploader-form {
      .avatar-uploader {
        width: 50%;
        border: 1px dashed #8c939d;
        height: 120px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .el-upload {
          width: 100%;
        }
        .el-icon-plus {
          font-size: 20px;
        }

        .el-upload__text {
          line-height: 1;
        }
      }
    }
  }
}

.fj-wrapper{
  color:$primary;
  cursor:pointer;
}
</style>